import { color, Root } from '@amcharts/amcharts5';
import { IXYAxis } from '@amcharts/amcharts5/.internal/charts/xy/series/XYSeries';
import {
  IAxisLabelSettings,
  ICategoryAxisSettings,
  IColumnSeriesSettings,
  IValueAxisSettings,
  IXYChartSettings,
} from '@amcharts/amcharts5/xy';

import { FrameHealthStatus } from 'features/Health/components/FrameHealthChart/types/frameHealthStatus';
import { xAxisRenderer, yAxisRenderer } from 'utils/charts/charts';
import { AxisRendererSettings } from 'utils/charts/setAxisRenderer';
import { CursorSettings } from 'utils/charts/setCursor';
import { PALETTE_GRAY_600, PALETTE_PRIMARY_DARK } from 'utils/colours';

export const getXYChartSettings = (): IXYChartSettings => ({
  panX: false,
  panY: false,
  maxTooltipDistance: 0,
});

export const yAxisSettings = (root: Root): ICategoryAxisSettings<any> => ({
  categoryField: 'dimension',
  startLocation: 0,
  endLocation: 1,
  renderer: yAxisRenderer(root, {}),
});

export const xAxisSettings = (root: Root): IValueAxisSettings<any> => ({
  min: 0,
  max: 100,
  numberFormat: "#'%'",
  strictMinMax: true,
  calculateTotals: true,
  renderer: xAxisRenderer(root, {
    strokeOpacity: 0.1,
  }),
});

export const columnSeriesSettings = (
  xAxis: IXYAxis,
  yAxis: IXYAxis,
  frameHealthStatus: FrameHealthStatus
): IColumnSeriesSettings => ({
  name: frameHealthStatus.displayLabel,
  stacked: true,
  xAxis: xAxis,
  yAxis: yAxis,
  valueXField: frameHealthStatus.status,
  valueXShow: 'valueXTotalPercent',
  categoryYField: 'dimension',
  fill: color(frameHealthStatus.color),
});

export const formattingSettings = {
  numberFormatter: {
    numberFormat: '#.#',
    numericFields: ['valueXTotalPercent'],
  },
};

const fontSettings: IAxisLabelSettings = {
  fontSize: '0.875rem',
  fontWeight: '400',
  fontFamily: 'Inter, -apple-system, Arial, sans-serif',
};

export const yAxisRendererSettings: AxisRendererSettings = {
  renderer: {
    minGridDistance: 24,
  },
  labels: {
    ...fontSettings,
    paddingRight: 16,
  },
  grids: {
    visible: false,
    forceHidden: true,
  },
};

export const xAxisRendererSettings: AxisRendererSettings = {
  renderer: {
    minGridDistance: 60,
  },
  labels: {
    ...fontSettings,
    fill: color(PALETTE_PRIMARY_DARK),
    paddingTop: 16,
  },
  grids: {
    stroke: color(PALETTE_GRAY_600),
    strokeWidth: 2,
  },
};

export const cursorSettings: CursorSettings = {
  cursor: {},
  lineY: {
    visible: false,
  },
  lineX: {
    visible: false,
  },
};
